import { type FC } from 'react';
import cn from 'classnames';
import { Modal as DirectModal, type ModalProps as DirectModalProps, useStack } from '@direct-frontend/components'; // eslint-disable-line no-restricted-imports -- Разрешаем импортировать Modal
import { getContainerClassName } from './lib/getContainerClassName';
import { getOverlayClassName } from './lib/getOverlayClassName';
import { getSizeClassName } from './lib/getSizeClassName';
import { yaKitModalTestId } from '../../lib/testids';
import { DEFAULT_PREVENT_SCROLL } from './constants';
import { type ModalProps } from './types';
import styles from './Modal@desktop.module.css';

/*
 * Компонент для отображения модального окна с предзаданными значениями по умолчанию
 */
const Modal: FC<DirectModalProps & ModalProps> = function Modal(props) {
    const {
        size = 'normal',
        'data-testid': dataTestId = 'Sample',
        preventScroll = DEFAULT_PREVENT_SCROLL,
        position = 'center',
        dismissOnEsc = true,
        dismissOnOutsideClick = true,
        hasCloseButton = true,
        children,
        ...other
    } = props;

    const verticalStackClassName = useStack({ type: 'vertical' });
    const classNameBySize = getSizeClassName(size, verticalStackClassName);
    const overlayClassNameBySize = getOverlayClassName(size);
    const containerClassNameBySize = getContainerClassName(size);

    return (
        <DirectModal
            {...other}
            data-testid={yaKitModalTestId(dataTestId)}
            className={cn(styles.Modal, classNameBySize, other.className)}
            overlayClassName={cn(other.overlayClassName, overlayClassNameBySize)}
            containerClassName={cn(other.containerClassName, containerClassNameBySize)}
            hasCloseButton={hasCloseButton}
            dismissOnEsc={dismissOnEsc}
            position={position}
            dismissOnOutsideClick={dismissOnOutsideClick}
            preventScroll={preventScroll}
        >
            {children}
        </DirectModal>
    );
};

export default Modal;
